<template>
    <v-card class="info-guide" elevation="2">
      <v-card-title>
        Help Guide
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-list dense>
          <!-- Profile Picture -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Profile Picture
              </v-list-item-title>
              <v-list-item-subtitle>
                The user’s avatar image. If blank, no picture has been uploaded.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Name -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Name
              </v-list-item-title>
              <v-list-item-subtitle>
                The full name on file for this customer.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Clinic -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Clinic
              </v-list-item-title>
              <v-list-item-subtitle>
                The clinic this customer is attached to. Blank if none assigned.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Email -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Email
              </v-list-item-title>
              <v-list-item-subtitle>
                The customer’s login and contact email address.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- User ID -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                User ID
              </v-list-item-title>
              <v-list-item-subtitle>
                Unique Cognito identifier for this customer.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Created At -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Created At
              </v-list-item-title>
              <v-list-item-subtitle>
                Date & time when the account was first created.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Updated At -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Updated At
              </v-list-item-title>
              <v-list-item-subtitle>
                Date & time of the most recent profile update.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Email Verified -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Email Verified
              </v-list-item-title>
              <v-list-item-subtitle>
                “Yes” means the user has confirmed their email; “No” means they haven’t.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Status -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Status
              </v-list-item-title>
              <v-list-item-subtitle>
                Cognito account status:
                <ul class="status-list">
                  <li><strong>Enabled</strong>: User can log in.</li>
                  <li><strong>Disabled</strong>: User has been blocked by an admin.</li>
                  <li><strong>Archival</strong>: Account has been marked for removal.</li>
                </ul>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Role -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Role
              </v-list-item-title>
              <v-list-item-subtitle>
                The user’s permission group (e.g., Admin, Support, Practitioner).
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
  
          <!-- Actions -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Reset Password / Resend Activation
              </v-list-item-title>
              <v-list-item-subtitle>
                Click to send a password-reset email or resend the sign-up confirmation link.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  export default {
    name: "InfoGuide",
  };
  </script>
  
  <style scoped>
  .info-guide {
    /* Provide ample width and center the card */
    max-width: 700px;
    width: 95%;
    margin: 24px auto;
    padding-bottom: 16px;
    overflow: visible !important;
  }
  
  /* Ensure all subtitles wrap properly */
  .v-list-item-subtitle {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    display: block;
  }
  
  /* Style the nested status list */
  .status-list {
    list-style-type: disc;
    margin: 8px 0 0 20px;
    padding: 0;
  }
  
  /* Blue hover effect for the close button */
  .info-guide .v-card-title .v-btn:hover {
    background-color: #e3f2fd !important;
  }
  .info-guide .v-card-title .v-btn:hover .v-icon {
    color: #1976d2 !important;
  }
  </style>
  